var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9935 0.333984C3.3135 0.333984 0.333496 3.32065 0.333496 7.00065C0.333496 10.6807 3.3135 13.6673 6.9935 13.6673C10.6802 13.6673 13.6668 10.6807 13.6668 7.00065C13.6668 3.32065 10.6802 0.333984 6.9935 0.333984ZM9.14683 10.594L7.00016 9.30065L4.8535 10.594C4.60016 10.7473 4.28683 10.5207 4.3535 10.234L4.92016 7.79398L3.0335 6.16065C2.8135 5.96732 2.9335 5.60065 3.22683 5.57398L5.72016 5.36065L6.6935 3.06065C6.80683 2.78732 7.1935 2.78732 7.30683 3.06065L8.28016 5.35398L10.7735 5.56732C11.0668 5.59398 11.1868 5.96065 10.9602 6.15398L9.07349 7.78732L9.64016 10.234C9.70683 10.5207 9.40016 10.7473 9.14683 10.594Z",
    fill: "#E1A761"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.b047bad9dad2832532e1ac1a288d96de.svg";
export { ForwardRef as ReactComponent };